let activeRequestCount = 0;
const listeners = new Set();

const notify = () => {
  const isLoading = activeRequestCount > 0;
  listeners.forEach((listener) => listener(isLoading));
};

export const beginApiRequest = (config = {}) => {
  if (config.disableGlobalLoader || config.__globalLoaderTracked) return;

  config.__globalLoaderTracked = true;
  activeRequestCount += 1;
  notify();
};

export const endApiRequest = (config = {}) => {
  if (!config.__globalLoaderTracked) return;

  config.__globalLoaderTracked = false;
  activeRequestCount = Math.max(0, activeRequestCount - 1);
  notify();
};

export const subscribeApiRequestState = (listener) => {
  listeners.add(listener);
  listener(activeRequestCount > 0);

  return () => {
    listeners.delete(listener);
  };
};

export const isApiLoading = () => activeRequestCount > 0;
